import React from "react";
import { NumberInput } from "@revvsales/components";
import { RevvForm /* ErrorMessages */ } from "../../../../commonComponents";

import {
  CustomFieldComponentRules,
  CustomFieldComponentMessages,
} from "../../DynamicField/DynamicFieldComponents/CustomFieldRulesMap";
import { numberForamting } from "../../../../utils/globalUtils";

export default class PercentFieldFormMode extends React.Component {
  state = {
    percentfieldValues: {
      default: JSON.parse(JSON.stringify(this.props.initialProps.value)),
    },
  };

  _handleOnBlur = (event, value, handleBlur, isValidated) => {
    handleBlur(event);
    // If the field is validated & there is a value then only
    // make an API call and update the redux store
    if ((isValidated && value >= 0 && value <= 100) || value === "") {
      const { id } = this.props.initialProps;
      const prefix = numberForamting(value, "", "%");
      this.props._updateDynamicFieldsInDoc(
        id,
        value !== "" ? value : null,
        prefix,
      );
      this._checkForUpdateField(value);
    }
  };

  _checkForUpdateField = currentValue => {
    const { id, value: initialValue } = this.props.initialProps;
    if (initialValue !== currentValue) {
      this.props._updateField(id, currentValue);
      if (currentValue) {
        this.props.filledStatus(true);
      } else this.props.filledStatus(false);
    }
  };

  render() {
    const {
      id,
      label,
      placeholder /* docIsLocked */,
    } = this.props.initialProps;
    return (
      <React.Fragment>
        <RevvForm
          revvFormId={id}
          initialFormValue={this.state.percentfieldValues}
          customFieldName="PERCENT"
          customFieldComponentRules={CustomFieldComponentRules}
          validateOnChange
          customFieldComponentMessages={CustomFieldComponentMessages}
          render={formProps => {
            const { handleChange, handleBlur, messages, values } = formProps;
            return (
              <React.Fragment>
                <NumberInput
                  id={id}
                  name="default"
                  type="percentage"
                  className="percent-field-form-mode"
                  // className={`${
                  //   messages.default !== undefined &&
                  //   (messages.default.required !== "" ||
                  //     messages.default.minMax)
                  //     ? "danger-border"
                  //     : ""
                  // }`}
                  placeholder={`${placeholder || `Enter ${label}`}`}
                  onChange={event => handleChange(event)}
                  onBlur={event =>
                    this._handleOnBlur(
                      event,
                      values.default,
                      handleBlur,
                      !messages.default,
                    )
                  }
                  value={values.default}
                  disabled={this.props.isLocked}
                  autoFocus
                  data-test="percent-field-form-mode"
                />
                {/**
                <div>
                  {messages.default && (
                    <ErrorMessages messages={messages.default.minMax} />
                  )}
                </div>
                 */}

                {/* <JSONPretty id="json-pretty" data={allInAll} /> */}
              </React.Fragment>
            );
          }}
        />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/DocumentV2/FormView/FormModeComponents/PercentFieldFormMode.js